@let businessAccount = businessAccount$ | async;

<div class="modal-full-page-body">
  <h1 class="title">Create Financial Account</h1>

  <div class="form" [class.form-with-error]="formSubmitError">
    <form [formGroup]="createFinancialAccountForm">
      <rkt-form [form]="createFinancialAccountForm" [fields]="createFinancialAccountFields" [model]="formModel"></rkt-form>
    </form>

    <div class="my-3">
      <app-form-select-field
        label="Parent Financial Account"
        placeholder="Select a Parent Financial Account"
        [required]="true"
        [items]="parentFinancialAccountListItems"
        [loading]="parentFinancialAccountListLoading"
        (changed)="parentFinancialAccountId = $event"
        (scrolledToEnd)="onParentFinancialAccountSelectScrollToEnd()"
      ></app-form-select-field>
    </div>
  </div>

  @if (formSubmitError) {
    <div class="error-container">
      <div class="separator"></div>
      <div class="details-page-edit-form-error">{{ formSubmitError }}</div>
    </div>
  }

  <div class="footer">
    <div class="separator"></div>
    <div class="buttons">
      <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>

      <button
        rktButton
        type="submit"
        (click)="onSubmit()"
        [title]="'Add Financial Account'"
        [disabled]="createFinancialAccountForm.invalid || isLoading"
      >
        Add Financial Account
      </button>
    </div>
  </div>
</div>
